import React, { Component } from "react";

import styles from "./styles.scss";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import { actions as sitetreeActions } from "../../services/SiteTree/redux";
import {
	Button,
	Card,
	Select,
	MenuItem,
	Grid,
	CircularProgress,
	Radio,
	RadioGroup,
	FormControlLabel,
	Modal
} from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp, Close } from "@material-ui/icons";
import { actions as headeractions } from "../../components/Header/redux";
import TreeSelect from "../../components/TreeSelect/TreeSelect";
import CSSModules from "react-css-modules";
import SmartTable from "../../components/SmartTable/SmartTable";
import HtmlParser from "react-html-parser";
import { DateRangePicker } from "../../libs/react-date-range";
import { DateTime, number } from "../../utils";
import browser from "../../utils/browser";
import TempLine from "../../components/TempLine/TempLine";
import ShellPortal from "../../components/ShellPortal/ShellPortal";

import grid_s from "../../assets/Icons/grid_view_selected-01.png";
import list_s from "../../assets/Icons/list_view_selected-01.png";
import grid_us from "../../assets/Icons/grid_view_unselected-01.png";
import list_us from "../../assets/Icons/list_view_unselected-01.png";

import livecostsicon_grey from "../../assets/Icons/live_costs_grey-01.png";
import rulesicon_grey from "../../assets/Icons/rules_grey-01.png";
import livecostsicon_blue from "../../assets/Icons/live_costs_yellow-01.png";
import rulesicon_blue from "../../assets/Icons/rules_yellow-01.png";

import livecostsIcon from "../../assets/Icons/live_costs_dark-01.png";
import rulesIcon from "../../assets/Icons/rules_dark-01.png";
import banner from "../../assets/grotty-red-thing.jpg";

@CSSModules(styles, { allowMultiple: true })
class Sites extends Component {
	constructor(props) {
		super(props);
		this.state = {
			calenderSelectOpen: false
		};
		this.closeCalendar = this.closeCalendar.bind(this);
	}

	componentWillMount() {
		this.props.toggleHeaderSelect(false);
		this.props.startLiveData();
	}
	componentWillUnmount() {
		this.props.toggleHeaderSelect(true);
		this.props.stopLiveData();
	}

	changeTime(result) {
		result.selection.endDate = DateTime.endOf("day", result.selection.endDate);
		this.props.changeTime(result);
	}

	getThImpl(conf, key) {
		switch (conf.propName) {
			case "name":
				return (
					<th key={key} styleName="table-header th-left" sortable={conf.propName}>
						{HtmlParser(this.historicalNameFilter(conf.columnName))}
					</th>
				);
			case "numTickets":
			case "co2":
			case "spentToday":
			case "costPerHr":
			case "kw":
			case "kwh":
			case "currentAmbientC":
			case "humidity":
				return (
					<th key={key} styleName="table-header th-right" sortable={conf.propName}>
						{HtmlParser(this.historicalNameFilter(conf.columnName))}
					</th>
				);
			case "ambientC":
				return (
					<th key={key} styleName="table-header" sortable={conf.propName}>
						{HtmlParser(this.historicalNameFilter(conf.columnName))}
					</th>
				);
			default:
				return (
					<th key={key} styleName="table-header" sortable={conf.propName}>
						{HtmlParser(this.historicalNameFilter(conf.columnName))}
					</th>
				);
		}
	}

	historicalNameFilter(name) {
		return this.props.dataType === "Live" ? name : name.replace(/today/gi, "");
	}

	getTdImpl(propName, site, tMax, tMin) {
		switch (propName) {
			case "name":
				return (
					<td key={site.name}>
						<div styleName="td-content td-left"><strong>{site.name.replace(/site_/gi, "")}</strong></div>
					</td>
				);
			case "failedRules":
				return (
					<td key={site.name}>
						<div styleName="td-content" style={{ color: site.failedRules > 0 ? "#ED6959" : "#66AABE", fontWeight: 600 }}>
							{number.parseNumber(site.failedRules)}
						</div>
					</td>
				);
			case "spentToday":
				return (
					<td key={site.name}>
						{!isNaN(site.spentToday) && (
							<div styleName="td-content td-right"><span styleName="dollar">$</span>{number.parseNumber(site.spentToday, 2)}</div>
						)}
					</td>
				);
			case "costPerHr":
				return (
					<td key={site.name}>
						{!isNaN(site.costPerHr) && (
							<div styleName="td-content td-right"><span styleName="dollar">$</span>{number.parseNumber(site.costPerHr, 2)}</div>
						)}
					</td>
				);
			case "ambientC":
				return (
					<td key={site.name} styleName="ambient-temp-line">
						<div styleName="td-content">
							<TempLine siteName={site.name} maxTemp={site.ambientMax} minTemp={site.ambientMin} totalMaxTemp={tMax} totalMinTemp={tMin} />
						</div>
					</td>
				);
			case "kw":
				return (
					<td key={site.name}>
						{!isNaN(site.kw) && <div styleName="td-content td-right">{number.formatInt(site.kw)}</div>}
					</td>
				);
			case "kwh":
				return (
					<td key={site.name}>
						{!isNaN(site.kwh) && <div styleName="td-content td-right">{number.formatInt(site.kwh)}</div>}
					</td>
				);
			case "humidity":
				return (
					<td key={site.name}>
						<div styleName="td-content td-right">{!isNaN(site[propName]) ? number.parseNumber(site[propName]) : site[propName]}%</div>
					</td>
				);
			case "currentAmbientC":
				return (
					<td key={site.name}>
						<div styleName="td-content td-right">{number.parseNumber(site.currentAmbientC, 1)}</div>
					</td>
				);
			case "co2":
				return (
					<td key={site.name}>
						<div styleName="td-content td-right">{number.parseNumber(site.co2, 0)}</div>
					</td>
				);
			default:
				return (
					<td key={site.name}>
						<div styleName="td-content td-right">
							{!isNaN(site[propName]) ? number.parseNumber(site[propName]) : site[propName]}
						</div>
					</td>
				);
		}
	}

	renderList() {
		const isHistorical = this.props.dataType === "Historical";
		return (
			<div styleName="list-wrap">
				<div styleName="list-table">
					{
						this.props.dataType !== "Historical" &&
						<img src={banner} styleName="banner" alt=""/>
					}
					<Grid container>
						<Grid xs={12} item container>
							<SmartTable
								columns={14}
								smartTableId="SitesListTable"
								data={this.props.sites}
								useResponsiveColumns={true}
								breakOn="sm"
								allowColumnSort={true}
								changeData={newData => this.props.changeData(newData)}
								tableClass="table-class"
								collapsedTableHeadersClass="td-content responsive-header"
								tdClass="st-td"
								classes={styles}
							>
								<thead>
									<tr>
										<th styleName="table-header" />
										{this.props.columnConf.columns
											.filter(
												x =>
													(isHistorical && !x.hideHistorical) ||
													(!isHistorical && !x.hideLive)
											)
											.map((conf, i) => this.getThImpl(conf, i))}
									</tr>
								</thead>
								<tbody>
									{this.props.sites.map((x, i) => {
										return (
											<tr key={i} styleName="table-row">
												<td>
													<div styleName="td-content ">
														<div styleName="rowicon-container rowicon-container-green marg-left8 marg-right8">
															<img
																styleName="rowicon hover-off"
																src={livecostsicon_grey}
																alt=""
															/>
															<img
																styleName="rowicon hover-on"
																src={livecostsIcon}
																alt=""
																onClick={() => {
																	this.props.setCurrentSiteByName(x.name);
																	this.props.navigate("/Live");
																}}
															/>
														</div>
														<div styleName="rowicon-container rowicon-container-blue">
															<img
																styleName="rowicon hover-off"
																src={rulesicon_grey}
																alt=""
															/>
															<img
																styleName="rowicon hover-on"
																src={rulesIcon}
																alt=""
																onClick={() => {
																	this.props.setCurrentSiteByName(x.name);
																	this.props.navigate("/Rules/" + x.name);
																}}
															/>
														</div>
													</div>
												</td>
												{this.props.columnConf.columns
													.filter(
														x =>
															(isHistorical && !x.hideHistorical) ||
															(!isHistorical && !x.hideLive)
													)
													.map(conf => {
														return this.getTdImpl(conf.propName, x, this.props.ambientMax, this.props.ambientMin);
													})}
											</tr>
										);
									})}
								</tbody>
							</SmartTable>
						</Grid>
					</Grid>
				</div>
			</div>
		);
	}

	renderGrid() {
		return (
			<div styleName="grid-wrap">
				{this.props.sites &&
					this.props.sites.map((x, i) => {
						const hasFailingOutcome = x.failedRules > 0;
						return (
							<div key={i} styleName="outer-card-wrap">
								<div styleName="grid-card-wrap">
									<div styleName="top">
										<div styleName="top-card">
											<h3 styleName="grid-header">{x.name.replace(/site_/gi, "")}</h3>
											<p styleName="state-text">
												{x._tree.HasChildren === true &&
													this.props.sitesMap[x._tree.children[0]] &&
													this.props.sitesMap[x._tree.children[0]].state}
											</p>
											<div
												styleName={
													hasFailingOutcome
														? "svg-container black-shadow"
														: "svg-container blue-shadow"
												}
												onMouseEnter={(evt) => this.props.mouseEnterCircle(evt, x)}
												onMouseLeave={(evt) => this.props.mouseLeaveCircle(evt, x)}
												onMouseMove={(evt) => this.props.mouseMoveCircle(evt, x)}
											>
												<svg width="120px" height="120px" viewBox="0 0 400 400" styleName="svg">
													<path
														d="M 200 370 a 170 170 0 1 1 1 0 Z"
														stroke={hasFailingOutcome === true ? "#E9393A" : "#2E9BB1"}
														strokeWidth={7}
														fill="none"
														strokeLinecap="round"
														strokeDashoffset={
															1135 -
															(1135 * ((x.failedRules / x.totalRules) * 100 || 0)) / 100
														}
														strokeDasharray={[1135]}
														origin="200,200"
													/>

													<text
														x="200"
														y="240"
														styleName="svg-text"
														textAnchor="middle"
														fill={hasFailingOutcome === true ? "#E9393A" : "#2E9BB1"}
														style={{cursor: "default"}}
													>
														{x.failedRules}
													</text>
												</svg>
											</div>
											<p styleName="f-text">Failed Rules</p>
										</div>
									</div>
									<div styleName="card-bot">
										<div styleName="botleft">
											<div
												styleName="small-card"
												onClick={() => {
													this.props.setCurrentSiteByName(x.name);
													this.props.navigate("/Live");
												}}
											>
												{" "}
												<img styleName="icon" src={livecostsIcon} />
												<div>Live Costs</div>
											</div>
										</div>
										<div styleName="botright">
											<div
												styleName="small-card"
												onClick={() => {
													this.props.setCurrentSiteByName(x.name);
													this.props.navigate("/Rules/" + x.name);
												}}
											>
												<img styleName="icon" src={rulesIcon} />
												<div>Rules</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						);
					})}
			</div>
		);
	}

	closeCalendar() {
		this.setState({ calenderSelectOpen: false });
	}

	sameDay(d1, d2) {
		return (
			d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
		);
	}

	render() {
		return (
			<div styleName="outer">
				{this.props.isBusy && (
					<div styleName="spinner">
						<CircularProgress />
					</div>
				)}
				<div styleName="header">
					<div styleName="btnwrap">
						{this.props.viewType === "grid" && !browser.isIE() && (
							<img src={grid_s} styleName="iconbtn" onClick={() => this.props.toggleView("grid")} />
						)}
						{this.props.viewType === "list" && !browser.isIE() && (
							<img src={grid_us} styleName="iconbtn" onClick={() => this.props.toggleView("grid")} />
						)}
						{this.props.viewType === "list" && !browser.isIE() && (
							<img src={list_s} styleName="iconbtn" onClick={() => this.props.toggleView("list")} />
						)}
						{this.props.viewType === "grid" && !browser.isIE() && (
							<img src={list_us} styleName="iconbtn" onClick={() => this.props.toggleView("list")} />
						)}
					</div>
					<div styleName="areawrap">
						<div styleName="select-wrap">
							<TreeSelect
								selectId="sitesSelect"
								value={this.props.viewSelected}
								onChange={item => {
									this.props.setView(item);
								}}
								actions={this.props.views}
								textClass="select-text"
								containerClass="calender-select"
								classes={styles}
							/>
						</div>
						{this.props.viewType === "list" && <div styleName="areawrap-left" />}
					</div>
					<div styleName="areawrap">
						{this.props.viewType === "list" && (
							<div styleName="select-wrap">
								<div
									styleName="calender-select"
									onClick={() =>
										this.setState({ calenderSelectOpen: !this.state.calenderSelectOpen })
									}
								>
									<p styleName="select-text">
										{this.props.dataType === "Historical" &&
											this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
											DateTime.formatToLocaleLongDate(this.props.time.startDate)}
										{this.props.dataType === "Historical" &&
											!this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
											(this.props.time
												? DateTime.formatToLocaleLongDate(this.props.time.startDate) +
												  " - " +
												  DateTime.formatToLocaleLongDate(this.props.time.endDate)
												: this.props.dataType)}
										{this.props.dataType !== "Historical" && this.props.dataType}
									</p>
									{this.state.calenderSelectOpen && <KeyboardArrowUp />}
									{!this.state.calenderSelectOpen && <KeyboardArrowDown />}
								</div>
								<Modal
									open={this.state.calenderSelectOpen}
									style={{ display: "flex", justifyContent: "center" }}
									onClose={() => {
										this.setState({ calenderSelectOpen: false });
									}}
								>
									<div className="modal-wrap">
										<div className="modal-header">
											Data Type{" "}
											<Close onClick={() => this.setState({ calenderSelectOpen: false })} />
										</div>
										<div styleName="calender-dropdown">
											<div>
												<div styleName="datatype-select">
													<RadioGroup
														row={true}
														value={this.props.dataType}
														onChange={e => this.props.toggleDataType(e.target.value)}
													>
														<FormControlLabel
															value="Live"
															control={<Radio color="primary" />}
															label={<div style={{color: "#333"}}>Live</div>}
														/>
														<FormControlLabel
															value="Historical"
															control={<Radio color="primary" />}
															label={<div style={{color: "#333"}}>Historical</div>}
														/>
													</RadioGroup>
												</div>
												{this.props.dataType === "Historical" && (
													<div styleName="drpContainer">
														<DateRangePicker
															ranges={[this.props.time]}
															dragSelectionEnabled={false}
															showSelectionPreview={false}
															onChange={s => this.changeTime(s)}
															// scroll={{ enabled: true }}
														/>
														<div styleName="drpCloseButtonContainer">
															<div style={{ flex: 1 }} />
															<div
																styleName="drpCloseButton"
																onClick={() => this.closeCalendar()}
															>
																Close
															</div>
														</div>
													</div>
												)}
											</div>
										</div>
									</div>
								</Modal>
							</div>
						)}
					</div>
				</div>
				<div styleName="content">
					{this.props.viewType === "grid" && this.renderGrid()}
					{this.props.viewType === "list" && this.renderList()}
				</div>
				{
					<div id="sites-tooltip" className={"pst-tooltip" + (this.props.isMouseIn && this.props.mouseSiteFailList !== null && this.props.mouseSiteFailList.length > 0 ? " force-visible" : " force-invisible")} style={{visibility: "hidden"}}>
							<div className="sites-tooltip-header">
								Currently failing rules:
							</div>
							{
								this.props.mouseSiteFailList.map((siteFail, index) => {
									return (
										<div key={index} className="sites-tooltip-text">
											{siteFail.name}
										</div>
									)
								})
							}
					</div>
				}
			</div>
		);
	}
}

const bindAction = dispatch => {
	return {
		startLiveData: () => dispatch(actions.startLiveData()),
		stopLiveData: () => dispatch(actions.stopLiveData()),
		toggleHeaderSelect: (val) => dispatch(headeractions.toggleHeaderSelect(val)),
		toggleView: s => dispatch(actions.toggleView(s)),
		changeData: s => dispatch(actions.setSiteLiveData(s)),
		changeTime: time => dispatch(actions.changeTime(time)),
		toggleDataType: s => dispatch(actions.toggleDataType(s)),
		setView: s => dispatch(actions.setView(s)),

		mouseEnterCircle: (evt, x) => dispatch(actions.mouseEnterCircle(evt, x)),
		mouseLeaveCircle: (evt, x) => dispatch(actions.mouseLeaveCircle(evt, x)),
		mouseMoveCircle: (evt, x) => dispatch(actions.mouseMoveCircle(evt, x)),

		setCurrentSiteByName: s => dispatch(sitetreeActions.setCurrentSiteName(s)),

		navigate: (uri, data) => dispatch(router.push(uri, data)),
		goBack: () => dispatch(router.goBack())
	};
};

const mapStateToProps = state => ({
	viewType: state.sites.viewType,
	dataType: state.sites.dataType,
	viewSelected: state.sites.viewSelected,
	sites: state.sites.sites,
	views: state.sites.views,
	time: state.sites.time,
	columnConf: state.sites.columnConf,
	sitesMap: state.sites.sitesMap,

	isMouseIn: state.sites.isMouseIn,
	mouseSite: state.sites.mouseSite,
	mouseX: state.sites.mouseX,
	mouseY: state.sites.mouseY,
	mouseSiteFailList: state.sites.mouseSiteFailList,

	ambientMax: state.sites.ambientMax,
	ambientMin: state.sites.ambientMin,

	isBusy: state.sites.isBusy,
	errors: state.sites.errors,
	hasError: state.sites.hasError
});

export default connect(
	mapStateToProps,
	bindAction
)(Sites);



// WEBPACK FOOTER //
// ./src/ui/Home/Home.js